// Module
var code = "<h2 id=\"taxes\">Taxes</h2> <p>View and print your personalized tax information.</p> ";
// Exports
export default code;